import { useInvestmentTransactionContext } from "../../contexts/VpsTransaction";

import Select from "react-select";
import "react-toastify/dist/ReactToastify.css";
import NumberFormat from "react-number-format";

import { Row, Col, Card, CardBody, CardHeader, CardTitle } from "reactstrap";
import { numberWithCommas } from "../../utils/customFunction";

export default function AllocationChange() {
  const {
    fields,
    removeSubFundsBlock,
    errors,
    typeVPS,
    currAmount,
    subFundsBlocks,
    customStyles,
    navLoading,
    viewMode,
    handleSubFundAccountChange,
    currentSubFundsBlock,
    setTypeVPS,
    handleAmountChange,
  } = useInvestmentTransactionContext();

  if (["withdrawal", "investment"].includes(viewMode)) return <></>;
  if (["withdrawal", "investment"].includes(fields.txnr_type)) return <></>;

  return (
    <>
      <Row>
        {fields.amc_code && fields.folio_no ? (
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">Current Systematic investment</CardTitle>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <div className="form-group">
                      <label>Allocation Scheme</label>
                      <div>
                        <input
                          disabled
                          className="form-control"
                          value={typeVPS}
                        />
                      </div>
                    </div>
                  </Col>

                  <Col>
                    <div className="form-group">
                      <label>Amount</label>
                      <div>
                        <NumberFormat
                          thousandSeparator={true}
                          value={currAmount}
                          placeholder="Enter Amount to Invest"
                          className={`form-control ${
                            errors &&
                            "withdrawal" in errors &&
                            errors.withdrawal
                              ? "border-danger"
                              : ""
                          }`}
                          disabled
                        />
                        {errors?.withdrawal && (
                          <small className="text-danger d-block mt-1">
                            {errors?.withdrawal}
                          </small>
                        )}
                      </div>
                    </div>
                  </Col>
                </Row>

                {fields.folio_no &&
                  currentSubFundsBlock.map((block, blockIndex) => {
                    return (
                      <div
                        key={block.id}
                        style={{
                          marginBottom: "15px",
                        }}
                      >
                        <div
                          style={{
                            display: "flex",
                            justifyContent: "end",
                            alignItems: "center",
                            marginBottom: "10px",
                          }}
                        >
                          {subFundsBlocks.length > 1 && (
                            <button
                              type="button"
                              onClick={() => removeSubFundsBlock(block.id)}
                              style={{
                                background: "none",
                                border: "none",
                                fontSize: "18px",
                                color: "#dc3545",
                                cursor: "pointer",
                                padding: "0",
                              }}
                            >
                              −
                            </button>
                          )}
                        </div>

                        <Row>
                          <Col>
                            <div className="form-group">
                              <label>Fund</label>
                              <div>
                                <Select
                                  isDisabled={true}
                                  value={block.selectedParentFund}
                                />
                              </div>
                            </div>
                          </Col>

                          <Col>
                            <div className="form-group">
                              <label>Current Investment</label>
                              <div style={{ position: "relative" }}>
                                <NumberFormat
                                  thousandSeparator={true}
                                  value={block?.total_holding || 0}
                                  className={`form-control pr-5`}
                                  disabled
                                  decimalScale={2}
                                  allowNegative={false}
                                />
                              </div>
                            </div>
                          </Col>
                        </Row>

                        {(block?.fund || block?.fund_code) && (
                          <>
                            {/* Header Row for SubFunds */}
                            <Row className="mt-3">
                              <Col>
                                <strong>Fund Name</strong>
                              </Col>
                              <Col>
                                <strong>Current Holding</strong>
                              </Col>
                              <Col>
                                <strong>Allocation %</strong>
                              </Col>
                            </Row>

                            {block?.subFunds?.map((ele: any, fundIndex) => {
                              return (
                                <Row key={fundIndex} className="mt-2">
                                  {/* Fund Name */}
                                  <Col>
                                    <div className="form-group">
                                      <input
                                        value={ele?.name}
                                        readOnly
                                        className="form-control"
                                      />
                                    </div>
                                  </Col>

                                  {/* Current Holding */}
                                  <Col>
                                    <div className="form-group">
                                      <NumberFormat
                                        thousandSeparator={true}
                                        value={ele?.holding || "0"}
                                        disabled
                                        className="form-control"
                                        decimalScale={4}
                                        allowNegative={false}
                                      />
                                    </div>
                                  </Col>

                                  {/* Proportion */}
                                  <Col>
                                    <div className="form-group">
                                      <div style={{ position: "relative" }}>
                                        <NumberFormat
                                          value={ele?.proportion}
                                          className={`form-control pr-5 `}
                                          disabled
                                        />
                                      </div>
                                    </div>
                                  </Col>
                                </Row>
                              );
                            })}
                          </>
                        )}
                      </div>
                    );
                  })}
              </CardBody>
            </Card>
          </Col>
        ) : null}
      </Row>

      <Row>
        {fields.amc_code && fields.folio_no ? (
          <Col md="12">
            <Card>
              <CardHeader>
                <CardTitle tag="h4">
                  Systematic investment{" "}
                  {errors["units_0"] && (
                    <span className="text-danger">{errors["units_0"]}</span>
                  )}
                </CardTitle>
              </CardHeader>
              <CardBody>
                <Row>
                  <Col>
                    <div className="form-group">
                      <label>Allocation Scheme</label>
                      <div>
                        <div>
                          <Select
                            value={{ label: typeVPS, value: typeVPS }}
                            label={"Select"}
                            isDisabled={true}
                            onChange={(e) => {
                              setTypeVPS(e?.value);
                            }}
                            menuPortalTarget={document.body}
                            menuShouldBlockScroll={true}
                            isClearable={true}
                            isSearchable={true}
                            name="color"
                            styles={customStyles}
                          />
                        </div>
                      </div>
                    </div>
                  </Col>
                </Row>

                {subFundsBlocks.map((block, blockIndex) => {
                  return (
                    <div
                      key={block.id}
                      style={{
                        marginBottom: "15px",
                      }}
                    >
                      <div
                        style={{
                          display: "flex",
                          justifyContent: "end",
                          alignItems: "center",
                          marginBottom: "10px",
                        }}
                      >
                        {subFundsBlocks.length > 1 && (
                          <button
                            type="button"
                            onClick={() => removeSubFundsBlock(block.id)}
                            style={{
                              background: "none",
                              border: "none",
                              fontSize: "18px",
                              color: "#dc3545",
                              cursor: "pointer",
                              padding: "0",
                            }}
                          >
                            −
                          </button>
                        )}
                      </div>

                      <Row>
                        <Col>
                          <div className="form-group">
                            <label>Fund</label>
                            <div>
                              <Select
                                isDisabled={true}
                                value={block.selectedParentFund}
                              />
                            </div>
                          </div>
                        </Col>

                        <Col>
                          <div className="form-group">
                            <label>Current Investment</label>
                            <div style={{ position: "relative" }}>
                              <NumberFormat
                                thousandSeparator={true}
                                value={block?.total_holding || 0}
                                className={`form-control pr-5`}
                                disabled
                                decimalScale={2}
                                allowNegative={false}
                              />
                            </div>
                          </div>
                        </Col>
                      </Row>

                      {!navLoading && (block?.fund || block?.fund_code) && (
                        <>
                          {/* Header Row for SubFunds */}
                          <Row className="mt-3">
                            <Col md={2}>
                              <strong>Fund Name</strong>
                            </Col>
                            <Col md={2}>
                              <strong>Account</strong>
                            </Col>
                            <Col md={2}>
                              <strong>Current Holding</strong>
                            </Col>
                            <Col md={3}>
                              <strong>Amount</strong>
                              <div className="d-flex justify-content-between">
                                <strong>Out</strong>
                                <strong className="pr-5">In</strong>
                              </div>
                            </Col>

                            <Col md={2}>
                              <strong>Units</strong>
                            </Col>

                            {/* <Col>
                              <strong>Select Fund</strong>
                            </Col> */}
                          </Row>

                          {block?.subFunds?.map((ele: any, fundIndex) => {
                            const isWithdrawalExceeded =
                              viewMode === "withdrawal" &&
                              parseFloat(ele?.units || "0") >
                                parseFloat(ele?.holding || "0");

                            return (
                              <Row key={fundIndex} className="mt-2">
                                {/* Fund Name */}
                                <Col md={2}>
                                  <div>
                                    <h4
                                      className="font-weight-bold"
                                      style={{ margin: 0 }}
                                    >
                                      {ele?.name}
                                    </h4>
                                  </div>
                                </Col>

                                {/* Account Dropdown */}
                                <Col md={2}>
                                  <div className="form-group">
                                    <Select
                                      options={ele?.accounts || []}
                                      value={ele?.selected_account}
                                      isDisabled={viewMode === "view"}
                                      onChange={(selected) =>
                                        handleSubFundAccountChange(
                                          block.id,
                                          fundIndex,
                                          selected
                                        )
                                      }
                                      placeholder="Select Account"
                                      isClearable
                                      isSearchable
                                      styles={customStyles}
                                    />
                                  </div>
                                </Col>

                                {/* Current Holding */}
                                <Col md={2}>
                                  <div className="d-flex pt-2 pb-2 text-md justify-content-center">
                                    <h5 className="mr-4">
                                      Units:{" "}
                                      <span className="font-weight-bold">
                                        {numberWithCommas(
                                          parseFloat(ele?.holding).toFixed(4) ||
                                            "0"
                                        )}
                                      </span>
                                    </h5>
                                    <h5 className="">
                                      Amount:{" "}
                                      <span className="font-weight-bold">
                                        {numberWithCommas(
                                          parseFloat(
                                            (
                                              parseFloat(
                                                parseFloat(
                                                  ele?.holding
                                                ).toFixed(4)
                                              ) * ele?.nav
                                            ).toFixed(4)
                                          ) || "0"
                                        )}
                                      </span>
                                    </h5>
                                  </div>
                                </Col>

                                {/* Current Holding in Amount */}
                                <Col md={3}>
                                  <div className="d-flex form-group">
                                    <NumberFormat
                                      thousandSeparator={true}
                                      value={ele?.amount_out || "0.00"}
                                      disabled={
                                        viewMode === "view" ||
                                        ele?.amount_in > 0
                                      }
                                      onValueChange={(values) => {
                                        const { value } = values;
                                        handleAmountChange(
                                          block.id,
                                          fundIndex,
                                          parseFloat(value) || 0,
                                          "out" // Changed from "in" to "out"
                                        );
                                      }}
                                      className={`form-control mr-2`}
                                      decimalScale={4}
                                      allowNegative={false}
                                    />
                                    <NumberFormat
                                      thousandSeparator={true}
                                      value={ele?.amount_in || "0.00"}
                                      disabled={
                                        viewMode === "view" ||
                                        ele?.amount_out > 0
                                      }
                                      onValueChange={(values) => {
                                        const { value } = values;
                                        handleAmountChange(
                                          block.id,
                                          fundIndex,
                                          parseFloat(value) || 0,
                                          "in" // Changed from "out" to "in"
                                        );
                                      }}
                                      className="form-control "
                                      decimalScale={4}
                                      allowNegative={false}
                                    />
                                  </div>
                                </Col>

                                {/* Units */}
                                <Col md={2}>
                                  <div className="form-group">
                                    <NumberFormat
                                      thousandSeparator={true}
                                      value={ele?.units || "0.0000"}
                                      disabled
                                      className={`form-control
                                          ${
                                            ele?.amount_in > 0
                                              ? "border-success text-success"
                                              : ""
                                          }
                                                    ${
                                                      isWithdrawalExceeded ||
                                                      ele?.amount_out > 0
                                                        ? "border-danger text-danger"
                                                        : ""
                                                    }`}
                                      decimalScale={4}
                                      allowNegative={false}
                                    />
                                    {isWithdrawalExceeded && (
                                      <small className="text-danger d-block mt-1">
                                        Exceeds holding ({ele?.holding})
                                      </small>
                                    )}
                                  </div>
                                </Col>

                                {/* <Col>
                                  <div className="form-group">
                                    <div>
                                      <Select
                                        disabled={
                                          (viewMode as string) !==
                                          "changeofallocation"
                                        }
                                        value={
                                          ele?.counter_fund.value
                                            ? ele?.counter_fund
                                            : null
                                        }
                                        placeholder={"Select Sub Fund"}
                                        className={`text-nowrap ${
                                          errors[`fund_slect:${fundIndex}`]
                                            ? "border-danger text-danger"
                                            : ""
                                        }`}
                                        onChange={(selectedFund) => {
                                          if (selectedFund) {
                                            setIndexedError(
                                              `fund_slect:${fundIndex}`,
                                              null
                                            );
                                            handleSubFundChange(
                                              block?.id,
                                              fundIndex,
                                              selectedFund
                                            );
                                          } else
                                            handleSubFundChange(
                                              block?.id,
                                              fundIndex,
                                              { value: "", label: "" }
                                            );
                                        }}
                                        menuPortalTarget={document.body}
                                        menuShouldBlockScroll={true}
                                        isClearable={true}
                                        isSearchable={true}
                                        options={renderVPSFundsDropdown(
                                          ele?.fund_code
                                        )}
                                        styles={customStyles}
                                      />
                                      {errors[`fund_slect:${fundIndex}`] && (
                                        <span className="text-danger">
                                          {errors[`fund_slect:${fundIndex}`]}
                                        </span>
                                      )}
                                    </div>
                                  </div>
                                </Col> */}
                              </Row>
                            );
                          })}
                        </>
                      )}

                      {navLoading && (
                        <div style={{ textAlign: "center", padding: "20px" }}>
                          <i
                            className="fa fa-spinner fa-spin"
                            style={{ fontSize: "24px", color: "#007bff" }}
                          ></i>
                          <div>Loading NAV data...</div>
                        </div>
                      )}
                    </div>
                  );
                })}
              </CardBody>
            </Card>
          </Col>
        ) : null}
      </Row>
    </>
  );
}
